import { BordOneToneIcon, NudosButton } from 'components/NudosComponents';
import UploadForm from 'views/bulkUpload/components/UploadForm/UploadForm';
import { useEffect, useState } from 'react';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { downloadQuotesTemplate } from 'services/bulkUpload/uploadQuotes.service';
import { QUOTE_TYPE } from 'types/bulkUpload';
import QuoteTypeSelector from './components/QuoteTypeSelector/QuoteTypeSelector';
import './DownloadQuotesStep0.scss';

interface DownloadQuotesStep0Props {
  selectedQuoteType?: QUOTE_TYPE;
  setSelectedQuoteType: (quoteType: QUOTE_TYPE) => void;
  nextStep: () => void;
}

const DownloadQuotesStep0 = ({ selectedQuoteType, setSelectedQuoteType, nextStep }: DownloadQuotesStep0Props) => {
  const [isDownloadingTemplate, setIsDownloadingTemplate] = useState(false);

  const downloadTemplate = async () => {
    const template = await downloadQuotesTemplate();
    window.open(template);
  };

  const handleDownloadTemplate = async () => {
    setIsDownloadingTemplate(true);
    try {
      await downloadTemplate();
      nextStep();
    } catch (error) {
      if (error instanceof SyntaxError) {
        displayErrorNotification({
          customJSXMessage: <>Error en los datos, por favor verifica la información ingresada.</>
        });
      }
    } finally {
      setIsDownloadingTemplate(false);
    }
  };

  useEffect(() => {
    if (!selectedQuoteType) {
      setSelectedQuoteType(QUOTE_TYPE.REGULAR);
    }
  }, [selectedQuoteType, setSelectedQuoteType]);
  return (
    <UploadForm
      uploadInfo={{
        title: 'Selecciona el cliente y el tipo de cotización para solicitar cotizaciones',
        description: 'Descarga la plantilla para cargar los productos que el cliente necesita.',
        icon: 'employee'
      }}
      hideFileInput
      hideAlert
      customClassName="downloadUploadQuotesFormStep0"
      showSeparatorInOptions={false}
      customContentBeforeOptions={
        <QuoteTypeSelector
          selectedQuoteType={selectedQuoteType || QUOTE_TYPE.REGULAR}
          onSelectQuoteType={setSelectedQuoteType}
        />
      }
      customSubmitSection={
        <NudosButton
          buttonIcon={<BordOneToneIcon variant="download" customWidth="10px" stroke="white" />}
          buttonText="Descargar plantilla y continuar"
          customHeight="44px"
          customClassName="downloadUploadQuotesFormStep0Button"
          handleClick={handleDownloadTemplate}
          isButtonLoading={isDownloadingTemplate}
        />
      }
    />
  );
};

export default DownloadQuotesStep0;
